export const masterType = {
    app : "App",
    button : "Button",
    departmentResource : "Department Resource",
    notification : "Notification",
    report : "Report",
    technologyResource : "Technology Resource",
    training : "Training",
    trainingHelp : "Training Help",
    widget : "Widget"
}